import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import {
  UploadZone,
  UploadIcon,
  UploadText,
  FileName,
  ExistingResumeCard,
  ButtonRow,
  BackLink,
} from "../choose-profile.styles";

const AISetup = ({
  onBack,
  onFileUpload,
  onUseExisting,
  isUploading = false,
}) => {
  const [file, setFile] = useState(null);
  const [hasExistingResume, setHasExistingResume] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("resume-info")) {
      setHasExistingResume(true);
    }
  }, []);

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0];
    if (selected) setFile(selected);
  };

  return (
    <div style={{ width: "100%" }}>
      {hasExistingResume && (
        <ExistingResumeCard>
          <div className="info">
            <i className="pi pi-file" />
            <span>You already have a parsed resume</span>
          </div>
          <Button
            label="Use it"
            size="small"
            className="p-button-text"
            onClick={onUseExisting}
          />
        </ExistingResumeCard>
      )}

      <UploadZone htmlFor="resume-upload" $hasFile={!!file}>
        <input
          id="resume-upload"
          type="file"
          accept=".pdf,.csv"
          onChange={handleFileChange}
        />
        {file ? (
          <>
            <UploadIcon>
              <i className="pi pi-check" />
            </UploadIcon>
            <FileName>
              <i className="pi pi-file" />
              {file.name}
            </FileName>
            <UploadText>Click to choose a different file</UploadText>
          </>
        ) : (
          <>
            <UploadIcon>
              <i className="pi pi-cloud-upload" />
            </UploadIcon>
            <UploadText>
              <strong>Click to upload</strong> or drag and drop
              <br />
              PDF or CSV — max 10 MB
            </UploadText>
          </>
        )}
      </UploadZone>

      {file && (
        <ButtonRow>
          <Button
            label={isUploading ? "Analyzing…" : "Upload & Analyze"}
            icon={isUploading ? "pi pi-spin pi-spinner" : "pi pi-sparkles"}
            className="p-button-raised"
            disabled={isUploading}
            onClick={() => onFileUpload(file)}
          />
        </ButtonRow>
      )}

      <BackLink onClick={onBack}>
        <i className="pi pi-arrow-left" style={{ fontSize: "0.8rem" }} />
        Back to options
      </BackLink>
    </div>
  );
};

export default AISetup;
